import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import VueRouter from 'vue-router';
import { SdkPluginVue2 } from '@rready/sdk';
import { rreadyDynamicFields } from '@rready/dynamic-fields';
import { sentry } from '@rready/integration';
import { rreadyUi, toastMixin } from '@rready/design';
import {
  rreadyModuleActivity,
  rreadyModuleComments,
  rreadyModuleCountdown,
  rreadyModuleFeedback,
  rreadyModuleGenerics,
  rreadyModuleHistory,
  rreadyModuleLinking,
  rreadyModuleMarkdown,
  rreadyModuleNotifications,
  rreadyModuleServices,
  rreadyModuleSocial,
  rreadyModuleStructure,
  rreadyModuleTags,
  rreadyModuleTasks,
  rreadyModuleTeams,
  rreadyModuleTicket,
  rreadyModuleTopics,
  rreadyModuleUsers,
  rreadyModuleVirtualGoods,
  rreadyModuleWallet,
  rreadyModuleGlobalSearch,
  rreadyModuleDataView,
  rreadyModuleChat
} from '@rready/components';
import FontAwesomeIconCompat from './plugins/FontAwesomeIconCompat.vue';
import { SdkOptions } from './plugins/SdkConfiguration';
import { i18n } from './plugins/LocalizationConfiguration';
import App from './App.vue';
import router from './router';
import { resourceMixin } from './mixin/resourceMixin';
import { modalMixin } from './mixin/modalMixin';

import '@fortawesome/fontawesome-pro/css/all.css';
import './plugins/FontAwesome';

const isDev = process.env.NODE_ENV === 'development';

Vue.config.productionTip = isDev;

sentry.init('rready-portal', Vue, router);

// Register the components for BaseDynamicField.vue
Vue.use(rreadyDynamicFields);

Vue.use(SdkPluginVue2, SdkOptions);
Vue.component('fa-icon-compat', FontAwesomeIconCompat);
Vue.use(rreadyUi);
Vue.mixin(toastMixin);
Vue.use(rreadyModuleActivity);
Vue.use(rreadyModuleCountdown);
Vue.use(rreadyModuleFeedback);
Vue.use(rreadyModuleGenerics);
Vue.use(rreadyModuleHistory);
Vue.use(rreadyModuleLinking);
Vue.use(rreadyModuleMarkdown);
Vue.use(rreadyModuleNotifications);
Vue.use(rreadyModuleServices);
Vue.use(rreadyModuleVirtualGoods);
Vue.use(rreadyModuleStructure);
Vue.use(rreadyModuleTags);
Vue.use(rreadyModuleTicket);
Vue.use(rreadyModuleTasks);
Vue.use(rreadyModuleComments);
Vue.use(rreadyModuleTeams);
Vue.use(rreadyModuleUsers);
Vue.use(rreadyModuleTopics);
Vue.use(rreadyModuleSocial);
Vue.use(rreadyModuleWallet);
Vue.use(rreadyModuleGlobalSearch);
Vue.use(rreadyModuleDataView);
Vue.use(rreadyModuleChat);
Vue.mixin(modalMixin);
Vue.mixin(resourceMixin);

const pinia = createPinia();
Vue.use(PiniaVuePlugin);

Vue.use(VueRouter);

new Vue({
  pinia,
  i18n,
  router,
  render: (h) => h(App)
}).$mount('#app');
